import { useTranslation } from 'react-i18next';
import { useEffect, useState, useContext, useRef } from 'react';
import "./Company.scss"
import '../../../i18n';
import { format } from 'react-string-format';
import InputWrapperRefacture from '../../UI/Inputs/InputWrapperRefacture';
import { APIGet, APIPost } from '../../API/APIRequest';
import { CheckoutPage } from '../CheckoutPage';
import Checkbox from '../../UI/Checkbox/Checkbox';
import Dropdown from '../../UI/Dropdown/Dropdown';
import Autocomplete from '../../UI/Autocomplete/Autocomplete';
import ErrorBox from '../../UI/ErrorBox/ErrorBox';
import { checkIsBlank, checkIsInvalid } from '../../Utilities/FieldValidations';
import { PaymentFormContext, billingCompany } from '../../Order/PaymentFormReducer';
import MessageBox from '../../UI/MessageBox/MessageBox';
import SuccessBox from '../../UI/SuccessBox/SuccessBox';
import ShimmerInput from '../../UI/ShimmerInput/ShimmerInput';
import { GetADToken } from '../../Utilities/TokenManager';

export function Company(props) {
    const { t, i18n } = useTranslation();
    const { setVatChanged, 
        companyProperties, 
        setBasketErrors, 
        selectedCompany, 
        setBasket, 
        purchasingFor, 
        setIsFilled, 
        basket, 
        fid, 
        vatDetails, 
        setSelectedCompany, 
        IsFilled, 
        addressType, 
        vatError, 
        setErrorStates, 
        IsInvalid, 
        setIsInvalid , 
        fieldLoading, 
        billingSectionLoading,
        countryCode} = props;
    const [fieldProps, setFieldProps] = useState()
    const [IsBlank, setIsBlank] = useState({ company: false, vatNo: false });
    const [IsValid, setIsValid] = useState({vatNo:basket?.taxcode ? "true" : ""})
    const [IsApplied, setIsApplied] = useState(basket?.taxcode || false)
    const [companyList, setCompanyList] = useState([]);
    const [company, setCompany] = useState();
    const [searchTerm, setSearchTerm] = useState("");
    const [companyAddress, setCompanyAddress] = useState("");
    const [isChecked, setIsChecked] = useState(basket?.taxcode || false);
    const [showCompanyList, setShowCompanyList] = useState(false);
    const [vatNo, setVatNo] = useState(basket?.taxcode || props.vatNo || null);
    const [refreshal, setRefreshal] = useState(true);
    const [showCompanyAddress, setShowCompanyAddress] = useState(false);
    const [fieldsToShow, setFieldsToShow] = useState([]);

    const latestSearchTermRef = useRef("");

    const getSavedDeliveryCompanyAddressDetails = () => {
    try {
        return JSON.parse(
            sessionStorage.getItem(
                "deliveryCompanyAddressDetails"
            )
        );
    } catch {
        return null;
    }
};

  
    useEffect(() => {

        //for billing needs to work on mount and country change too.Needs further optimisation
        const details = getSavedDeliveryCompanyAddressDetails();

        if (countryCode && addressType === "billingAddress") {
            let deliveryCountryCodeFromSession = details?.deliveryCountryCode;

            if ((deliveryCountryCodeFromSession !== countryCode) || !details) {
                getCompanyAddressConfig();
            } else {
                setValuesFromSession(details);
            }
        }

    }, [countryCode])

    useEffect(() => {

        //needs to work on mounting
        if (addressType === "deliveryAddress") {

            const details = getSavedDeliveryCompanyAddressDetails();
            let deliveryCountryCodeFromSession = details?.deliveryCountryCode;

            if ((deliveryCountryCodeFromSession !== countryCode) || !details) {
                getCompanyAddressConfig();
            } else {
                setValuesFromSession(details);
            }
        }

    }, [])

    const setValuesFromSession=(details)=>{

       setShowCompanyAddress(details?.showAddressConfig);
       setFieldsToShow(details?.companyAddressFields ?? [])

   }
   
    const getCompanyAddressFields = (config) => {

        APIGet({
            "controller": "company",
            "action": "getcompanyaddressfields",
            "environment": null,
            "identifier":countryCode

        }).then((response) => {
           
            let companyAddressFields = response.data.companyaddressfields
            setFieldsToShow(companyAddressFields);
            
            if(addressType==="deliveryAddress"){
              const deliveryCompanyAddressDetails = {
                deliveryCountryCode: countryCode,
                showAddressConfig:config,
                companyAddressFields,
               };

              sessionStorage.setItem(
              "deliveryCompanyAddressDetails",
               JSON.stringify(deliveryCompanyAddressDetails)
              );
            }
        }).catch(function (errors) {

            console.log("Error in fetching company address fields")

        })

    }


    const getCompanyAddressConfig = () => {

        APIGet({
            "controller": "company",
            "action": "showcompanyaddress",
            "environment": null,
             "identifier":countryCode

        }).then((response) => {
            
            let showAddressConfig = response.data.showaddressfields;
            setShowCompanyAddress(showAddressConfig);

            if(showAddressConfig) {
                getCompanyAddressFields(showAddressConfig);
            }


        }).catch(function (errors) {

            console.log("Error in fetching company address config")

        })}


  
    const getUserEmail = () => GetADToken()?.username || "";

   const companySuggestions = (term) => {

        const userEmail = getUserEmail();
    
        const trimmedTerm = term?.trim() || "";

        APIGet({
            "controller": "company",
            "action": "getcompanysuggestions",
            "environment": null,
            "identifier": trimmedTerm || null,
            "data": { email: userEmail }
        }).then((response) => {
        
            if (trimmedTerm !== (latestSearchTermRef.current?.trim() || "")) return;

            if (response.data.success) {
                setCompanyList([...response.data.companies])
                
            }
        }).catch((error) => {
                var unexpected = [];
                unexpected.push("error.unexpected");

            });
    }

   //to show compnay list on focus of company field- reults are from domain matching - if there are anyy
    useEffect(() => {
        if (!showCompanyList || searchTerm) return;

        const timer = setTimeout(() => {
            companySuggestions("");
        }, 300);

        return () => clearTimeout(timer);
    }, [showCompanyList, searchTerm]);

    // Effect to trigger debounced API call when searchTerm changes
    useEffect(() => {
        latestSearchTermRef.current = searchTerm;

        if (!searchTerm || !showCompanyList) return;

        const timer = setTimeout(() => {
            companySuggestions(searchTerm);
        }, 300);

        return () => clearTimeout(timer);
    }, [searchTerm]);


    useEffect(() => {
       
        if (companyProperties && Object.keys(companyProperties).length !== 0) {
          
            setFieldProps(companyProperties);
            setIsFilled(IsFilled => ({ ...IsFilled, COMPANY: { filled: true, mandatory: companyProperties?.mandatory } }))
            
          }
          
    }, [companyProperties])

 
    useEffect(() => { 
       if ((company || company === "")) {
        setSelectedCompany({COMPANY: company?.name, CompanyId: company?.id || null})

        if(fieldProps?.mandatory){
         updateCompanyFilledState(company?.name)
        }}

    //   if(company?.id && companyAddress && addressType === "billingAddress"){
    //     setSelectedCompany(selectedCompany => ({ ...selectedCompany, ADDRESS: companyAddress }))
    //    }  

     }, [company])

    
    const handleOnVatChange = (action) => {

        if(vatNo){

        const commonPayload = {
            origincountrycode: basket.origincountrycode,
            destinationcountrycode: basket.destinationcountrycode,
            origincountycode: basket.origincountycode,
            destinationcountycode: basket.destinationcountycode,
            purchaseTarget: purchasingFor || "unknown",
        };
    
        let payload = {};
    
        if (!IsApplied || action=== "recalculate") {
            payload = {
                ...commonPayload,
                taxcode: vatNo || null,
            };
         
        } else {
            payload = {
                ...commonPayload,
                taxcode: "",
                }; 
        }
    
        APIGet({
            controller: "basket",
            action: "recalculatetax",
            environment: null,
            data: payload,
            identifier: fid,
        })
        .then((response) => {
            if (response.data?.basket) {
                let basket = response.data.basket;
                if (basket.defaultpaymentprovider === "stripe") {
                    APIPost({
                        controller: "stripe",
                        action: "updatepaymentintentamount",
                        environment: null,
                        data: {
                            basketId: fid
                        }
                    }).then((response)=>{
                        if(response.data.success){
                            props.setPaymentElementReload(true)
                        }
                      }).catch((error)=>{
                        console.log("Error in updating stripe payment intent")
                     });
                }
                if (!IsApplied || action=== "recalculate") {
                    setBasket(response.data?.basket);
                    setIsValid({ vatNo: "true" });
                    setSelectedCompany((selectedCompany) => ({ ...selectedCompany, vatNo: vatNo }));
                    setIsApplied(true);
                    setVatChanged(true);
                 
                    APIPost({
                        controller: "company",
                        action: "updatetaxcode",
                        environment: null,
                        data: { taxcode: vatNo },
                        identifier: company.id,
                    });
                } else { 
                    setVatNo("");
                    setBasket(response.data?.basket);
                    setIsValid({ vatNo: "" }); //initial value
                    setSelectedCompany((selectedCompany) => ({ ...selectedCompany, vatNo: "" }));
                    setIsApplied(false);
                    setVatChanged(false);
                }
                
            }
        })
        .catch((error) => {
            if (error?.response?.data?.errors) {
                setIsValid({ vatNo: "false" });
            }

            if (error.response && error.response.status === 400)  {
                const errorData = error.response.data;
        
                if (errorData.errors && errorData.errors.includes('error.basketcompletedorder')) {
                  // Handling the specific error related to a completed order
                  setBasketErrors(errorData.errors);
                  setBasket({});
               
                } 
                
              } 
          });
    }else{
        setIsValid({vatNo: "empty"})
    }
        props.isVatApplied(!IsApplied);
   
    };
    
    const handleOnBlur = (e) => {

      
        if (e.target.value && checkIsInvalid(e.target.value, "address")) {
            setIsInvalid(IsInvalid => ({ ...IsInvalid, COMPANY: { invalid: true, mandatory: true } }))
        }
        else {
            setIsInvalid(IsInvalid => ({ ...IsInvalid, COMPANY: { invalid: false, mandatory: true } }))
        }
        if (e.target.value && fieldProps.mandatory) {
           updateCompanyFilledState(e.target.value);
        }
        if (!vatNo || vatNo.length === 0) {
            setIsValid({ vatNo: "" })
        }
    }

    const updateCompanyFilledState=(value)=>{
          if (value?.length > 0) {
                setIsFilled(IsFilled => ({ ...IsFilled, COMPANY: { filled: true, mandatory: true } }))
            }
            else {
                setIsFilled(IsFilled => ({ ...IsFilled, COMPANY: { filled: false, mandatory: true } }))}
             }

    const handleVatInput = (e) => {
        let value = e.target.value;
        setRefreshal(false);
        if (!IsApplied) {
            if (value) {
                setVatNo(e.target.value)
                setIsValid({ vatNo: "" }) 
           
            } else {
                setVatNo(null)
              
            }
           
        }
    }

    const handleCheckboxChange = (event) => {
        const checked = event.target.checked; 
        setIsChecked(!isChecked); 
    
        props.isVatChecked(checked);
        if (checked) {
            setFieldProps({ ...companyProperties, "mandatory": true })
        } else {
            setFieldProps({ ...companyProperties})
        }
       
    };


   useEffect(()=>{

        if((basket?.origincountrycode || basket?.destinationcountrycode) && vatNo){
            handleOnVatChange();  //anytime country changes Vatcode needs to be emptied
        }

        setIsChecked(false);
      
    }, [basket?.origincountrycode, basket?.destinationcountrycode])    

    useEffect(()=>{

        if((basket?.origincountycode || basket?.destinationcountycode) && vatNo && !refreshal){

            handleOnVatChange("recalculate");  //anytime county changes recalculation of tax is needed.
        }

    }, [basket?.destinationcountycode, basket?.origincountycode])


    useEffect(() => {
        if (IsApplied) { 
            setErrorStates(errorData => ({ ...errorData, isVatEmpty: false }))  
        }
   
    }, [IsApplied])


  return (<>

       {billingSectionLoading ? <div className="item-container">
                                   <div className="item-wrapper"> 
                                       <ShimmerInput/> 
                                    </div>
                                </div> 
        :
        
        <>
        <div className="item-container">
            <div className="item-wrapper">
                
                   <Autocomplete
                    setShowCompanyList={setShowCompanyList}
                    label={fieldProps && fieldProps.label }
                    id={fieldProps && fieldProps.fieldName}
                    name={fieldProps && fieldProps.fieldName}
                    placeholder={fieldProps?.placeHolderText}
                    fieldLoading={fieldLoading}
                    type="text"
                    inputFieldType="text"
                    invalidClass={(!isChecked ? (IsFilled?.COMPANY && !IsFilled.COMPANY?.filled && fieldProps?.mandatory && "Invalid-input") : (selectedCompany?.COMPANY?.length <= 0 || selectedCompany?.COMPANY?.length === undefined) && "Invalid-input") || (IsInvalid?.COMPANY && IsInvalid.COMPANY?.invalid && "Invalid-input")}
                    aria-invalid={(IsFilled?.COMPANY && !IsFilled.COMPANY?.filled && fieldProps?.mandatory) || (IsInvalid?.COMPANY && IsInvalid.COMPANY?.invalid)}
                    aria-describedby={`${[fieldProps?.fieldName]}-errors`}
                    optionalField={!fieldProps?.mandatory}
                    onBlurFunction={(e) => {handleOnBlur(e)}}
                    inputSize="full-width"
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    setValue={setCompany}
                    setAddress={setCompanyAddress}
                    propValue={selectedCompany?.COMPANY}
                    options={companyList}
                    dropdownName="company"
                    showCompanyAddress={showCompanyAddress}
                    fieldsToShow={fieldsToShow}
                />
              
                {(((IsFilled?.COMPANY && !IsFilled?.COMPANY?.filled) && fieldProps?.mandatory && !isChecked)) && 
                    <span role="alert" id={`${[fieldProps?.fieldName]}-errors`}> 
                            <ErrorBox>{fieldProps ? format(t('addressfields.blankerrortext'), fieldProps?.label) : t('biilingdetails.blankcompany')}</ErrorBox>
                    </span>}
                {(isChecked && (selectedCompany?.COMPANY?.length <= 0 || selectedCompany?.COMPANY?.length === undefined)) &&
                    <span role="alert" id={`${[fieldProps?.fieldName]}-errors`}>
                        <ErrorBox>{fieldProps ? format(t('addressfields.blankerrortext'), fieldProps?.label) : t('biilingdetails.blankcompany')}</ErrorBox>
                    </span>}
                {(IsInvalid[fieldProps?.fieldName]?.invalid) &&
                    <span role="alert" id={`${[fieldProps?.fieldName]}-errors`}>
                        <ErrorBox>{format(t('addressfields.errortext'), fieldProps?.label)}</ErrorBox>
                    </span>}
            </div>

            {addressType === "billingAddress"  && vatDetails.showTaxCode && vatDetails.taxCodeFormat  ?
                <div className="item-wrapper">
                    <InputWrapperRefacture
                        labelText={t('checkout.taxtext')}
                        id="taxquestion"
                        name="taxquestion"
                        inputWidth="small"
                        type="text"
                        inputFieldType="checkbox"
                        checked={!isChecked}
                        onChange={handleCheckboxChange}
                    />
                   </div>
                : ""
            }
         </div>

      
        {addressType === "billingAddress"  && vatDetails.showTaxCode && vatDetails.taxCodeFormat && isChecked ? 
            <div className="item-container">
                <div className="item-wrapper">
           
                    <InputWrapperRefacture
                        label={t('checkout.vatlabel')}
                        id="vatNo"
                        name="vatNo"
                        type="text"
                        
                        onClickFunction={()=>handleOnVatChange()}  //the edit button should only show when psw-requires is on
                        btnText={!IsApplied ? t('checkout.vatapplybuttonlabel') : t('checkout.vatremovebuttonlabel')}
                        onBlur={(e) => { handleOnBlur(e, "vatNo") }}
                        onChange={(e) => { handleVatInput(e) }}
                        inputFieldType="text"
                        invalidClass={(props.errorStates?.isVatEmpty || IsBlank?.vatNo || IsValid?.vatNo==="false" || IsValid?.vatNo==="empty" ) && isChecked && "Invalid-input"}
                        aria-invalid={(props.errorStates?.isVatEmpty || IsBlank?.vatNo || IsValid?.vatNo==="false" || IsValid?.vatNo==="empty") && isChecked}
                        aria-describedby="vatNo-error"
                        inputSize="small"
                        value={vatNo || selectedCompany.vatNo} />
                       
                        {IsValid.vatNo==="false" &&  <span role="alert" id='vatNo-error'> <ErrorBox>{t('basket.invalidtaxcode')}</ErrorBox></span>}
                        {(IsValid.vatNo === "empty" || (props.errorStates?.isVatEmpty && IsValid.vatNo === '')) && <span role="alert" id='vatNo-error'><ErrorBox>{t('basket.blanktaxcode')}</ErrorBox></span>} 

                        {IsValid.vatNo==="true" && <span role="alert" id='vatNo-error'><SuccessBox>{t('basket.taxcodeapplied')}</SuccessBox></span>}
                    
                </div>

            </div>
            
            : ""}

          </>

          }
     </>
    );
}

